export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    return (
      // @ts-ignore
      parts.pop().split(';').shift() || ''
    )
  }

  return ''
}
